import { create } from 'zustand';

type CreateRequest = { connectionId: string };
type DeleteRequest = { connectionId: string; table: string };
type State = {
  createRequest?: CreateRequest;
  deleteRequest?: DeleteRequest;
  openCreate: (request: CreateRequest) => void;
  openDelete: (request: DeleteRequest) => void;
  closeCreate: () => void;
  closeDelete: () => void;
};

export const useStorageTableDialogStore = create<State>((set) => ({
  openCreate: (createRequest) => set({ createRequest }),
  openDelete: (deleteRequest) => set({ deleteRequest }),
  closeCreate: () => set({ createRequest: undefined }),
  closeDelete: () => set({ deleteRequest: undefined }),
}));

export const openCreateStorageTableDialog = (connectionId: string): void => useStorageTableDialogStore.getState().openCreate({ connectionId });
export const openDeleteStorageTableDialog = (connectionId: string, table: string): void => useStorageTableDialogStore.getState().openDelete({ connectionId, table });
